/**
 * Full-page shell for forgot-password (matches login card layout).
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Container } from '@mui/material';
import ForgotPasswordForm from '../components/auth/ForgotPasswordForm';
import Logo from '../components/common/Logo';

const ForgotPasswordPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      component="main"
      id="main-content"
      tabIndex={-1}
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        bgcolor: 'background.default',
        py: 4,
        outline: 'none',
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <Logo type="flahafast" size="medium" />
        </Box>
        <Card elevation={2} sx={{ borderRadius: 2 }}>
          <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
            <ForgotPasswordForm
              onBackToLogin={() => navigate('/login')}
              onSuccess={() => {
                /* stay on success state in form */
              }}
            />
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default ForgotPasswordPage;
